import { setupIonicReact } from '@ionic/react';
import { Provider } from 'react-redux';
import createStore from 'appRedux/createStore';
const store = createStore();

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useEffect, useState } from 'react';

import { mainKaPloint } from './common/PubSub';
import { SlotCheckRouter } from 'components/SlotCheckRouter';
import { SessionTimeoutWarning } from 'components/SessionTimeoutWarning';
import baseEnv from 'config/config';
import { Amplify } from 'aws-amplify';

setupIonicReact();
Amplify.configure(baseEnv().amplify);

interface ICurLocationResponse {
  postal?: string;
  city?: string;
}
const App: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [getLocationChecked, setGetLocationChecked] = useState(false);
  const [locationData, setLocationData] = useState<ICurLocationResponse>({});

  mainKaPloint.subscribe((loading: any) => {
    setLoading(loading as boolean);
  });

  function getCurrentZipCode(): Promise<ICurLocationResponse> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://ipapi.co/json/', true);

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText) {
          const response = JSON.parse(xhr.responseText) as object;
          resolve(response);
        } else {
          reject(new Error(xhr.statusText));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Request failed'));
      };

      xhr.send();
    });
  }

  useEffect(() => {
    let isIgnore = false;

    if (!isIgnore && getLocationChecked) {
      getCurrentZipCode()
        .then((data) => {
          setLocationData(data);
        })
        .catch((err) => console.log('getCurrentZipCode ERR', err));
    }
    return () => {
      isIgnore = true;
    };
  }, [getLocationChecked]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Provider store={store}>
        <SlotCheckRouter />
        {/* The app's one inactivity tracker + logout warning (lib/sessionExpiry). */}
        <SessionTimeoutWarning />
      </Provider>
    </MuiPickersUtilsProvider>
  );
};

export default App;
